var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      {
        ref: "_in",
        staticClass: "_sli",
        class: {
          _range: _vm.range,
          _slot: !!_vm.$slots.default,
          _drag: !!_vm.bound
        },
        style: { width: _vm.width, height: _vm.height },
        attrs: {
          id: _vm.id,
          disabled: _vm.disabled,
          inert: _vm.inert,
          tabindex: _vm.inert ? -1 : _vm.tabindex
        },
        on: {
          keydown: _vm._keypress,
          touchstart: _vm._touchstart,
          touchend: _vm._touchend
        }
      },
      _vm.__on
    ),
    [
      _c("div", { ref: "track", staticClass: "_trk" }),
      _c("div", {
        ref: "thumb0",
        staticClass: "_thm0",
        class: { _zero: _vm.ivalue == _vm.min }
      }),
      _vm.range ? _c("div", { ref: "thumb1", staticClass: "_thm1" }) : _vm._e(),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }